export default {
  // 用户满意度调研 数据提交
  postUserResearch(params) {
    return this.http('Bingo', 'post', '/api/v2/investigations', params);
  },
  // 提交中奖信息 数据提交
  postWinnerInfo(params) {
    return this.http('Status', 'post', '/api/v2/winning_records', params);
  },
  // 提交中奖信息 数据提交
  fetchWinnerInfo(params) {
    return this.http('Status', 'get', '/api/v2/winning_record', params);
  }
};
